export default function ExclamationMarkIcon({ color = '#FFCB05' }: { color?: string }) {
  return (
    <svg width="53px" height="53px" viewBox="0 0 53 53">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g>
          <polygon
            points="26.4996 -0.000100000005 -0.000400000001 26.5009 26.4996 52.9999 53.0006 26.5009"
            fill={color}
          />
          <path
            d="M24.5,39.054 L24.5,35.054 L28.5,35.054 L28.5,39.054 L24.5,39.054 Z M28.5,31.0536 L24.5,31.0536 L23.5,13.0536 L29.5,13.0536 L28.5,31.0536 Z"
            fill="#FFFFFF"
          />
        </g>
      </g>
    </svg>
  );
}
